import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PurchaseOrderStatusInterface } from '@app/interfaces/purchase-order-status.model';

import { PurchaseOrderConfig } from './configs/purchase-order.config';
import { IPurchaseOrderState } from './interfaces';
import { IPurchaseOrderShipment } from './interfaces/purchase-order.interface';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStateService {
  private initialState :IPurchaseOrderState = {
    currentShipment: null,
    currentQueryParams: PurchaseOrderConfig.defaultQueryParamsShipments,
    loadingShipments: false,
    loadingCurrentShipment: false,
    loadingPurchaseOrders: false,
    meta: null,
    purchaseOrders: [],
    shipments: [],
    shipmentStatus: [],
    submitting: false,
  };

  private _state$ = new BehaviorSubject<IPurchaseOrderState>(this.initialState);

  // Observable stream for components to subscribe to

  constructor() {}

  // Method to update the state
  updateState(newState :Partial<IPurchaseOrderState>) :void {
    // Update the state with new state
    this._state$.next({ ...this._state$.getValue(), ...newState });
  }

  get state$() {
    return this._state$.asObservable();
  }

  get state() :IPurchaseOrderState {
    return this._state$.getValue();
  }

  get loadingShipments$() :Observable<boolean> {
    return this.state$.pipe(map((state) => state.loadingShipments));
  }

  get currentShipment$() :Observable<IPurchaseOrderShipment> {
    return this.state$.pipe(map((state) => state.currentShipment));
  }

  get shipments$() :Observable<IPurchaseOrderShipment[]> {
    return this.state$.pipe(map((state) => state.shipments));
  }

  get shipmentStatus$() :Observable<PurchaseOrderStatusInterface[]> {
    return this.state$.pipe(map((state) => state.shipmentStatus));
  }

  get purchaseOrders$() :Observable<any[]> {
    return this.state$.pipe(map((state) => state.purchaseOrders));
  }

  get loadingPurchaseOrders$() :Observable<boolean> {
    return this.state$.pipe(map((state) => state.loadingPurchaseOrders));
  }

  get submitting$() :Observable<boolean> {
    return this.state$.pipe(map((state) => state.submitting));
  }

  get loadingCurrentShipment$() :Observable<boolean> {
    return this.state$.pipe(map((state) => state.loadingCurrentShipment));
  }
}
